import withSuspense from "../../../../hocs/withSuspense";
import { EditNamePageProps, EditNamePage } from "./EditNamePage";
import { ContactInfoSkeleton, SettingsError } from "../../components";

export const EditNamePageWithSuspense = withSuspense<EditNamePageProps>(
  EditNamePage,
  {
    FallbackComponent: SettingsError,
    loading: <ContactInfoSkeleton rows={3} testId="edit-name" />,
  }
);
